/**
 * Liten kopiera-ikon bredvid e-post och telefon. Visar "Kopierat" en kort stund.
 */
import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

async function kopiera(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Äldre webbläsare / osäker kontext: gå via ett dolt textfält.
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  }
}

export default function KopieraKnapp({ text, size = 12, sx }) {
  const [kopierat, setKopierat] = useState(false);
  if (!text) return null;
  return (
    <Tooltip title={kopierat ? 'Kopierat' : 'Kopiera'} open={kopierat || undefined} placement="top" arrow>
      <IconButton size="small"
        onClick={async e => {
          e.stopPropagation();
          e.preventDefault();
          if (await kopiera(String(text))) {
            setKopierat(true);
            setTimeout(() => setKopierat(false), 1500);
          }
        }}
        sx={{ p: 0.25, opacity: kopierat ? 1 : 0.45, color: kopierat ? '#2E7D32' : 'inherit',
          '&:hover': { opacity: 1 }, ...sx }}>
        {kopierat ? <CheckIcon sx={{ fontSize: size }} /> : <ContentCopyIcon sx={{ fontSize: size }} />}
      </IconButton>
    </Tooltip>
  );
}
